module.exports = __webpack_public_path__ + "img/grupo-modelo.9f1e4cf8.png";